import React from "react";
import { useSelector } from "react-redux";
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";


// needed to access keys in JSON by string dot notation
const jumpToKey = (obj, str) =>  {
  return str.split(".").reduce(function(o, x) { try { return o[x] } catch(ex) { return null} }, obj);
}

export function useRawTranslationObject(htmlContentIdentifier = null, key) {
  const tagOwner = useSelector(state => state.tagOwner)
  const stateLocale = useSelector(state => state.locale)

  if(htmlContentIdentifier == null) {
    htmlContentIdentifier = `translations.${stateLocale || tagOwner?.language || tagOwner?.locale}`
  }

  const translations = useSelector(state => (state.htmlContents || []).find(item => item.identifier === htmlContentIdentifier)?.json)

  return jumpToKey(translations ,key)
}

export function useRawTranslation(htmlContentIdentifier = null, returnNullIfMissing = false) {
  const tagOwner = useSelector(state => state.tagOwner)
  const stateLocale = useSelector(state => state.locale)

  if(htmlContentIdentifier == null) {
    htmlContentIdentifier = `translations.${stateLocale || tagOwner?.language || tagOwner?.locale}`
  }

  const translations = useSelector(state => (state.htmlContents || []).find(item => item.identifier === htmlContentIdentifier)?.json)

  return (key, fallbackTranslation, placeholders = {}) => {
    if(translations == null) {
      if(returnNullIfMissing) {
        return null
      }
      if (fallbackTranslation) {
        return fallbackTranslation
      }
      return "No identifier found for the translation HtmlContent. Please specify the identifier (useTranslation(\"{key}\")) in the html content \"{htmlContentIdentifier}\", or use state.locale or tagOwner.locale."
    }
    const translation = jumpToKey(translations,key)

    if(translation == null) {
      if(returnNullIfMissing) {
        return null
      }
      if (fallbackTranslation) {
        return fallbackTranslation
      }

      return `Missing translation \"${key}\" in translation table \"${htmlContentIdentifier}\".`
    }

    return translation
  }
}

export default function useTranslation(htmlContentIdentifier = null, returnNullIfMissing = false) {
  const tagOwner = useSelector(state => state.tagOwner)
  const stateLocale = useSelector(state => state.locale)

  if(htmlContentIdentifier == null) {
    htmlContentIdentifier = `translations.${stateLocale || tagOwner?.language || tagOwner?.locale}`
  }

  const translations = useSelector(state => (state.htmlContents || []).find(item => item.identifier === htmlContentIdentifier)?.json)

  return (key, placeholders = {}, fallbackTranslation) => {
    if(translations == null) {
      if(returnNullIfMissing) {
        return null
      }
      if (fallbackTranslation) {
        if (typeof fallbackTranslation === 'string' || fallbackTranslation instanceof String) {
          return <RenderedHtmlContent html={fallbackTranslation} placeholders={placeholders}/>;
        } else {
          return fallbackTranslation
        }
      }
      return <div className="alert alert-danger">
        No identifier found for the translation HtmlContent. Please specify the identifier (useTranslation("{key}")) in the html content "{htmlContentIdentifier}", or use state.locale or tagOwner.locale.
      </div>
    }
    const translation = jumpToKey(translations,key)

    if(translation == null) {
      if(returnNullIfMissing) {
        return null
      }
      if (fallbackTranslation) {
        if (typeof fallbackTranslation === 'string' || fallbackTranslation instanceof String) {
          return <RenderedHtmlContent html={fallbackTranslation} placeholders={placeholders}/>;
        } else {
          return fallbackTranslation
        }
      }

      return <div className="badge badge-danger bg-danger text-wrap" style={{width: "100%"}}>
        <p className="py-2">
          Missing translation "{key}" in translation table "{htmlContentIdentifier}".
        </p>
        <br/>
        <pre className={"text-wrap"}>{JSON.stringify(translations)}</pre>
      </div>;
    }

    return <RenderedHtmlContent html={translation} placeholders={placeholders}/>
  }
}

